/**
 * 异常 IP 风险（后端 650）重新登录 —— 纯函数工具集（cj-web-egg，CommonJS）。
 *
 * 不依赖任何项目模块，仅做 URL 拼装，便于单元测试（见 test/riskRelogin.test.js）。
 * 副作用（读 config.ossHost / location、跳转、clear()）保留在调用方（common/utils.js、
 * mycj/src/provider/commonjs/http.js、登录页 login.js）。
 *
 * 业务约定（方案 A，见需求 ADR-005 / FR-3）：「去登录」地址带 riskRelogin=1（登录页据此清除
 * 上一次登录信息）；「返回」地址不带标记（保留登录态）。
 */

var RISK_RELOGIN_KEY = "riskRelogin";
var RISK_RELOGIN_VALUE = "1";
var ACCOUNT_ANOMALY_PATH = "egg/account-anomaly.html";

/** 给「去登录」地址追加风险清除标记 riskRelogin=1 */
function withRiskReloginMarker(loginUrl) {
  if (!loginUrl) return loginUrl;
  var sep = loginUrl.indexOf("?") > -1 ? "&" : "?";
  return loginUrl + sep + RISK_RELOGIN_KEY + "=" + RISK_RELOGIN_VALUE;
}

/** 拼装异常提示页地址：{ossHost}/egg/account-anomaly.html?loginUrl=..&backUrl=.. */
function buildAccountAnomalyUrl(ossHost, loginUrl, backUrl) {
  var host = (ossHost || "").replace(/\/+$/, "");
  return (
    host +
    "/" +
    ACCOUNT_ANOMALY_PATH +
    "?loginUrl=" +
    encodeURIComponent(loginUrl) +
    "&backUrl=" +
    encodeURIComponent(backUrl)
  );
}

/**
 * 登录页守卫：仅当 search 含 riskRelogin=1（用户在提示页点了「去登录」）时返回 true。
 * @param {string} search location.search（可含或不含前导 ?）
 */
function shouldClearLoginOnEnter(search) {
  if (!search) return false;
  var normalized = search.charAt(0) === "?" ? search.slice(1) : search;
  var reg = new RegExp("(^|&)" + RISK_RELOGIN_KEY + "=([^&]*)(&|$)");
  var r = normalized.match(reg);
  return !!r && r[2] === RISK_RELOGIN_VALUE;
}

/** 是否为风险重新登录的业务 code（仅 650） */
function isRiskReloginCode(code) {
  return Number(code) === 650;
}

module.exports = {
  RISK_RELOGIN_KEY: RISK_RELOGIN_KEY,
  RISK_RELOGIN_VALUE: RISK_RELOGIN_VALUE,
  ACCOUNT_ANOMALY_PATH: ACCOUNT_ANOMALY_PATH,
  withRiskReloginMarker: withRiskReloginMarker,
  buildAccountAnomalyUrl: buildAccountAnomalyUrl,
  shouldClearLoginOnEnter: shouldClearLoginOnEnter,
  isRiskReloginCode: isRiskReloginCode,
};
